import "core-js/modules/es.array.push.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-52ed4866"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "ion-text-left ion-padding ion-no-margin"
};
const _hoisted_2 = {
  class: "ion-text-left toggle-label"
};
const _hoisted_3 = {
  key: 0,
  class: "time-confirmation"
};
import { modalController } from '@ionic/vue';
import { useForm } from 'vee-validate';
import { ref, onMounted } from 'vue';
import { useI18n } from 'vue-i18n';
import { object, string, boolean } from 'yup';
import router, { SIBTIME_MOMENTS_PATH, LEVELS_PATH } from '@/router';
import AppFormFieldItem from '@/components/AppFormFieldItem.vue';
import useSibTimeMoments from '@/composables/global/use-sibtime-moments';
import { SIBTIME_MOMENT_MINUTE_OPTIONS } from '@/models/user';
export default /*#__PURE__*/_defineComponent({
  __name: 'SibtimeMomentModal',
  setup(__props) {
    const {
      t
    } = useI18n({
      useScope: 'global',
      messages: {
        en: {
          SibtimeMomentsPage: {
            changePreferencesDescription: "If you change your mind, you can sign up for SibTime Moments at the end of the next chapter, or go to 'SibTime Moments' from the main menu to change your preferences or enjoy the SibTime Moments at your convenience.",
            changePreferencesLabel: 'You can always change your preferences from the SibTime Moments main menu.',
            gotIt: 'Got it',
            goToSibTimeMoments: 'Go to SibTime Moments',
            preferences: 'SibTime Moments Preferences',
            save: 'Save',
            sibtimeMoments: 'SibTime Moments',
            signedUp: 'Sign up to receive a daily, 2-minute SibTime Moment.',
            success: 'Success!',
            time: 'At what time?',
            triggerTimeSaved: 'You are all set up to receive SibTime Moments at {time}!'
          }
        },
        es: {
          SibtimeMomentsPage: {
            changePreferencesDescription: 'Si cambias de opinión, puedes registrarte para recibir Momentos de SibTime al final del próximo capítulo, o ir a "Momentos de SibTime" desde el menú principal para cambiar tus preferencias o disfrutar de los Momentos de SibTime a tu conveniencia.',
            changePreferencesLabel: 'Siempre puedes cambiar tus preferencias desde el menú principal de Momentos de SibTime.',
            gotIt: 'Entendido',
            goToSibTimeMoments: 'Ir a Momentos de SibTime',
            references: 'Preferencias de Momentos de SibTime',
            save: 'Guardar',
            sibtimeMoments: 'Momentos de SibTime',
            signedUp: 'Regístrate para recibir un Momento de SibTime diario de 2 minutos.',
            success: '¡Éxito!',
            time: '¿A qué hora?',
            triggerTimeSaved: '¡Estás listo para recibir Momentos de SibTime a las {time}!'
          }
        }
      }
    });
    const initialSibTime = ref();
    const {
      saveSibTimeMoment,
      getSibTimeMoment
    } = useSibTimeMoments();
    const initialValues = {
      signedUp: true,
      triggerTime: initialSibTime.value || '08:00 pm'
    };
    const schema = object({
      signedUp: boolean().required(),
      triggerTime: string().when('signedUp', {
        is: true,
        then: string().required(),
        otherwise: string().notRequired()
      })
    });
    const {
      meta,
      values: form,
      resetForm: discardChanges
    } = useForm({
      validationSchema: schema,
      initialValues
    });
    const isSaved = ref(false);
    async function save() {
      await saveSibTimeMoment(form.signedUp ? form.triggerTime : undefined);
      isSaved.value = true;
      discardChanges({
        values: {
          ...form
        }
      });
    }
    async function dismiss() {
      router.push(LEVELS_PATH);
      if (!isSaved.value) {
        await saveSibTimeMoment(undefined);
      }
      modalController.dismiss();
    }
    onMounted(async () => {
      const sibtimeMoment = await getSibTimeMoment();
      if (sibtimeMoment) {
        initialSibTime.value = sibtimeMoment.triggerTime || '08:00 pm';
      } else {
        initialSibTime.value = '08:00 pm';
      }
      discardChanges({
        values: {
          triggerTime: initialSibTime.value || '08:00 pm',
          signedUp: true
        }
      });
    });
    return (_ctx, _cache) => {
      const _component_ion_icon = _resolveComponent("ion-icon");
      const _component_ion_button = _resolveComponent("ion-button");
      const _component_ion_buttons = _resolveComponent("ion-buttons");
      const _component_ion_toolbar = _resolveComponent("ion-toolbar");
      const _component_ion_header = _resolveComponent("ion-header");
      const _component_ion_col = _resolveComponent("ion-col");
      const _component_ion_row = _resolveComponent("ion-row");
      const _component_ion_label = _resolveComponent("ion-label");
      const _component_ion_grid = _resolveComponent("ion-grid");
      const _component_ion_card = _resolveComponent("ion-card");
      const _component_ion_text = _resolveComponent("ion-text");
      const _component_ion_content = _resolveComponent("ion-content");
      const _component_ion_page = _resolveComponent("ion-page");
      return _openBlock(), _createBlock(_component_ion_page, null, {
        default: _withCtx(() => [_createVNode(_component_ion_header, {
          class: "ion-text-center"
        }, {
          default: _withCtx(() => [_createVNode(_component_ion_toolbar, null, {
            default: _withCtx(() => [_createVNode(_component_ion_buttons, {
              slot: "end"
            }, {
              default: _withCtx(() => [_createVNode(_component_ion_button, {
                onClick: dismiss
              }, {
                default: _withCtx(() => [_createVNode(_component_ion_icon, {
                  slot: "icon-only",
                  icon: "close"
                })]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_ion_content, null, {
          default: _withCtx(() => [_createElementVNode("h1", _hoisted_1, _toDisplayString(_unref(t)('SibtimeMomentsPage.sibtimeMoments')), 1), _createVNode(_component_ion_card, {
            color: "secondary"
          }, {
            default: _withCtx(() => [_createVNode(_component_ion_grid, null, {
              default: _withCtx(() => [_createVNode(_component_ion_row, null, {
                default: _withCtx(() => [_createVNode(_component_ion_col, {
                  size: "8",
                  offset: "1"
                }, {
                  default: _withCtx(() => [_createElementVNode("h2", _hoisted_2, _toDisplayString(_unref(t)('SibtimeMomentsPage.signedUp')), 1)]),
                  _: 1
                }), _createVNode(_component_ion_col, {
                  size: "3"
                }, {
                  default: _withCtx(() => [_createVNode(AppFormFieldItem, {
                    type: "toggle",
                    field: "signedUp",
                    lines: "none",
                    hideLabel: "",
                    class: "ion-no-padding high-contrast-toggle"
                  })]),
                  _: 1
                })]),
                _: 1
              }), _createVNode(_component_ion_row, {
                class: "ion-justify-content-center ion-no-padding"
              }, {
                default: _withCtx(() => [_createVNode(_component_ion_col, {
                  size: "auto"
                }, {
                  default: _withCtx(() => [_createVNode(_component_ion_label, null, {
                    default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(t)('SibtimeMomentsPage.time')), 1)]),
                    _: 1
                  })]),
                  _: 1
                })]),
                _: 1
              }), _createVNode(_component_ion_row, null, {
                default: _withCtx(() => [_createVNode(_component_ion_col, null, {
                  default: _withCtx(() => [_createVNode(AppFormFieldItem, {
                    type: "datetime",
                    field: "triggerTime",
                    lines: "none",
                    hideLabel: "",
                    class: "transparent-background",
                    disabled: !_unref(form).signedUp,
                    opts: {
                      presentation: 'time',
                      format: 'hh:mm aaa',
                      inline: true,
                      color: 'primary',
                      minuteValues: _unref(SIBTIME_MOMENT_MINUTE_OPTIONS)
                    }
                  }, null, 8, ["disabled", "opts"])]),
                  _: 1
                })]),
                _: 1
              }), _createVNode(_component_ion_row, {
                class: "ion-justify-content-center"
              }, {
                default: _withCtx(() => [_createVNode(_component_ion_col, {
                  class: "ion-padding",
                  size: "auto"
                }, {
                  default: _withCtx(() => [_createVNode(_component_ion_button, {
                    style: {
                      "width": "250px"
                    },
                    fill: "solid",
                    color: "primary",
                    onClick: save
                  }, {
                    default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(t)('SibtimeMomentsPage.save')), 1)]),
                    _: 1
                  })]),
                  _: 1
                })]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          }), isSaved.value ? (_openBlock(), _createBlock(_component_ion_grid, {
            key: 0
          }, {
            default: _withCtx(() => [_createVNode(_component_ion_row, null, {
              default: _withCtx(() => [_createVNode(_component_ion_col, {
                class: "ion-text-left ion-no-padding ion-padding-start"
              }, {
                default: _withCtx(() => {
                  var _unref$initialValues, _unref$initialValues2, _unref$initialValues3;
                  return [_createElementVNode("h1", null, _toDisplayString((_unref$initialValues = _unref(meta).initialValues) !== null && _unref$initialValues !== void 0 && _unref$initialValues.signedUp ? _unref(t)('SibtimeMomentsPage.success') : _unref(t)('SibtimeMomentsPage.gotIt')), 1), (_unref$initialValues2 = _unref(meta).initialValues) !== null && _unref$initialValues2 !== void 0 && _unref$initialValues2.signedUp ? (_openBlock(), _createElementBlock("h4", _hoisted_3, _toDisplayString(_unref(t)('SibtimeMomentsPage.triggerTimeSaved', {
                    time: _unref(meta).initialValues.triggerTime
                  })), 1)) : _createCommentVNode("", true), (_unref$initialValues3 = _unref(meta).initialValues) !== null && _unref$initialValues3 !== void 0 && _unref$initialValues3.signedUp ? (_openBlock(), _createBlock(_component_ion_text, {
                    key: 1
                  }, {
                    default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(t)('SibtimeMomentsPage.changePreferencesLabel')), 1)]),
                    _: 1
                  })) : (_openBlock(), _createBlock(_component_ion_text, {
                    key: 2
                  }, {
                    default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(t)('SibtimeMomentsPage.changePreferencesDescription')), 1)]),
                    _: 1
                  }))];
                }),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_ion_row, null, {
              default: _withCtx(() => [_createVNode(_component_ion_col, {
                class: "ion-padding-start"
              }, {
                default: _withCtx(() => [_createElementVNode("button", {
                  class: "link-button",
                  onClick: _cache[0] || (_cache[0] = $event => (dismiss(), _unref(router).push(_unref(SIBTIME_MOMENTS_PATH))))
                }, _toDisplayString(_unref(t)('SibtimeMomentsPage.goToSibTimeMoments')), 1)]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          })) : _createCommentVNode("", true)]),
          _: 1
        })]),
        _: 1
      });
    };
  }
});